import { client } from './client';

interface ShopConfiguration {
  shopId: number;
  name: string;
  country: string;
  properties: Array<{
    key: string;
    value: string;
  }>;
  customData: Record<string, unknown>;
  shopCustomData: Record<string, unknown>;
}

export const getScayleSiteConfig = () => {
  return client.shopConfiguration.get() as Promise<ShopConfiguration>;
};
